import React from "react";
import './ProgressCircle.css'

const ProgressCircle = (props: any) => {
  const {
    size = 170,
    progress = 0,
    trackWidth = 10,
    indicatorWidth = 10,
    indicatorCap = `round`,
    label = ``,
    labelColor = `#333`,
    spinnerMode = false,
    spinnerSpeed = 1,
    content = null,
    scale,
  } = props

  const center = size / 2;
  const radius = center - (trackWidth > indicatorWidth ? trackWidth : indicatorWidth);
  const dashArray = 2 * Math.PI * radius;
  const dashOffset = dashArray * ((100 - progress) / 100);

  const hideLabel = (size < 100 || !label.length || spinnerMode) ? true : false

  return (
    <React.Fragment>
      <div
        className="svg-pi-wrapper timerCircle"
        style={{ width: size, height: size }}
      >
        <svg
          className="svg-pi" 
          style={{ width: size, height: size }}
        >
          <circle
            className="svg-pi-track"
            cx={center}
            cy={center}
            fill="transparent"
            r={radius}
            strokeWidth={indicatorWidth * scale}
          />
          <circle
            className={`svg-pi-indicator ${
              spinnerMode ? "svg-pi-indicator--spinner" : ""
            }`}
            style={{ animationDuration: spinnerSpeed * 1000 }}
            cx={center}
            cy={center}
            fill="transparent"
            r={radius}
            strokeWidth={indicatorWidth * scale}
            strokeDasharray={dashArray}
            strokeDashoffset={isNaN(dashOffset) ? 0 : dashOffset}
            strokeLinecap={indicatorCap}
          />
        </svg>

        {
          (!hideLabel && (
            <div 
              className="svg-pi-label" 
              style={{ color: labelColor }}
            >
              <span className="svg-pi-label__loading">
                {label}
              </span>

              {!spinnerMode && (
                <span className="svg-pi-label__progress">
                  {`${
                    progress > 100 ? 100 : progress
                  }%`}
                </span>
              )}
            </div>
          )) || <div className="svg-pi-content h-100">{ content }</div>
        }
      </div>
    </React.Fragment>
  )
}

export default ProgressCircle